export default {

    getWxReady() {
        // wx.checkJsApi({
        //     jsApiList:['updateAppMessageShareData','updateTimelineShareData','onMenuShareAppMessage'],
        //     success:function(res){
        //         console.log('checkJsApi -> res',res)
        //     }
        // })
        const routeName = localStorage.getItem('path_url')
        const title = ['/recruitPolicy','/newHome'].indexOf(routeName) > -1 ? '壬华科技-财税数字化改革者-渠道伙伴赚钱模式' : '壬华科技-财税数字化改革者';
        wx.ready(function () {
            const imgUrl = 'https://renhua-invoice-oss.oss-cn-shenzhen.aliyuncs.com/public/logorenhua.png';
            const desc = '构建财税一体化解决方案，规避企业涉税风险';
            const url = window.location.href

            //分享给朋友
            if (wx.updateAppMessageShareData) {
                wx.updateAppMessageShareData({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: imgUrl, // 分享图标
                    success: function () {
                        // 设置成功
                    }
                })
            } else {
                //分享给朋友
                wx.onMenuShareAppMessage({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: imgUrl, // 分享图标
                    type: '', // 分享类型,music、video或link，不填默认为link
                    success: function () {
                        // 用户点击了分享后执行的回调函数
                    }
                })
            }
            if (wx.updateTimelineShareData) {
                //分享到朋友圈
                wx.updateTimelineShareData({
                    title: title, // 分享标题
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: imgUrl, // 分享图标
                    success: function () {
                        // 设置成功
                    }
                });
            } else {
                wx.onMenuShareTimeline({
                    title: title, // 分享标题
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: imgUrl, // 分享图标
                    success: function () {
                        // 设置成功
                    }
                })

            }
            wx.onMenuShareQQ({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: imgUrl, // 分享图标
                success: function () {
                    // 设置成功
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                }
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/utils/configuration.js